// 審査対象コンテキスト Resolver
// URL の caseId（および paramsInheritanceStrategy により継承された projectId）に対応する
// 審査対象詳細を CasesStore に選択状態として設定する
import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn } from '@angular/router';

import { CasesStore } from '../cases.store';

/**
 * caseContextResolver
 * cases/:caseId ルートで実行される。
 * paramsInheritanceStrategy: 'always' 設定により、祖先ルートの projectId を
 * route.params から直接取得できる。
 * casesStore.selectCase(projectId, caseId) を呼び出して選択審査対象を確定させる。
 */
export const caseContextResolver: ResolveFn<boolean> = async (
  route: ActivatedRouteSnapshot,
) => {
  const casesStore = inject(CasesStore);

  const projectId = route.params['projectId'] as string | undefined;
  const caseId = route.params['caseId'] as string | undefined;

  if (!projectId || !caseId) return true;

  await casesStore.selectCase(projectId, caseId);
  return true;
};
